const SET_ANALYST = 'setAnalyst'
const SET_ANALYSTS = 'setAnalysts'

export const mutationTypes = {
  SET_ANALYST,
  SET_ANALYSTS
}

export const mutations = {
  [SET_ANALYST] (state, payload) {
    state.analyst = payload
  },

  [SET_ANALYSTS] (state, payload) {
    state.analysts = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/analyst/mutations.js